const router = {
  path: '/ciamLogin',
  name: 'CiamLogin',
  component: () => import('@/views/login/ciamLogin')
}
export default router



// WEBPACK FOOTER //
// ./src/router/ciamLogin.js